const React = require('react');

const Overlay = require('./widgets/Overlay');

function saveName(name) {
  localStorage.setItem('feedback_name', name);
}

function loadName() {
  return localStorage.getItem('feedback_name') || '';
}

function sendFeedback(name, feedback, jalla) {
  saveName(name);

  const url = '/api/feedback';
  const page = location.href;
  const body = JSON.stringify({ name, feedback, page, jalla });

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  })
    .then(r => {
      if (r.ok) {
        return true;
      }
      else {
        throw new Error('Not able to send');
      }
    });
}

class FeedbackForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = { mode: 'idle', text: '', name: '', jalla: '' };
  }

  componentDidMount() {
    this.setState({ name: loadName() });
  }

  render() {
    const { text, name, mode, jalla } = this.state;
    const close = () => this.props.close();
    const setText = (e) => this.setState({ text: e.currentTarget.value });
    const setName = (e) => this.setState({ name: e.currentTarget.value });
    const setJalla = (e) => this.setState({ jalla: e.currentTarget.value });

    const submit = () => {
      this.setState({ mode: 'sending' });
      sendFeedback(name, text, jalla)
      .then(() => {
        this.setState({ mode: 'sent' });
      })
      .catch(() => this.setState({ mode: 'error' }));
    };

    const disabled = mode === 'sending';
    const done = mode === 'sent';

    if (done) {
      return (
        <Overlay onClose={close}>
          <div className="dialog feedback">
            Feedback sent. Thanks!
            <br/>
            <button className="primary" onClick={close}>Close</button>
          </div>
        </Overlay>
      );
    }
    const errorMsg = mode === 'error' && <div className="error">Sorry, not able to send 🙈</div>
    const canSend = !disabled && text.length > 5;

    // the "jalla" field is a hidden input meant to catch spam bots
    // idea is that bots will fill it out, on server we reject the feedback if field is not empty
    return (
      <Overlay onClose={close}>
        <div className="dialog feedback">
          <form className="form" onSubmit={e => e.preventDefault()} style={{ gap: 10 }}>
            Something missing or not working? Ideas for improvements? Tell us!
            <br />

            <textarea
              placeholder="Bugs, ideas, feedback"
              value={text}
              onChange={setText}
              disabled={disabled}
            />
            <input
              placeholder="Name / email (optional)"
              onChange={setName}
              value={name}
              disabled={disabled}
            />
            <input
              id="info"
              type="text"
              style={{ display: 'none' }}
              onChange={setJalla}
              value={jalla}
            />
            <div>
              <b>NOTE</b>: The feeback should be about the site itself, not the xAPI or RoomOS in general.
            </div>
            { errorMsg }
            <div>
              <button className="primary" disabled={!canSend} type="submit" onClick={submit}>Submit</button>
              <button onClick={close}>Close</button>
            </div>
          </form>
        </div>
      </Overlay>
    );
  }

};

module.exports = FeedbackForm;
